import { Dispatch, SetStateAction } from "react";
import * as React from "react";
import * as ToastPrimitive from "@radix-ui/react-toast";

export const Toast = React.forwardRef<
  React.ElementRef<typeof ToastPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ToastPrimitive.Root> & {
    title: string;
    description: string;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
  }
>(({ title, description, open, setOpen }, ref) => {
  return (
    <ToastPrimitive.Provider swipeDirection="right" duration={4000}>
      <ToastPrimitive.Root
        className="ToastRoot"
        open={open}
        onOpenChange={setOpen}
        ref={ref}
        onClick={() => setOpen(false)}
      >
        <ToastPrimitive.Title className="ToastTitle">
          {title}
        </ToastPrimitive.Title>
        <ToastPrimitive.Description className="ToastDescription">
          {description}
        </ToastPrimitive.Description>
      </ToastPrimitive.Root>
      <ToastPrimitive.Viewport className="ToastViewport" />
    </ToastPrimitive.Provider>
  );
});
